/**
 * Collection / tag filters use path URLs (/collections/all/vibe+jungle).
 * Update the grid via section AJAX so the open dropdown never closes.
 */
(function () {
  var parser = new DOMParser();
  var abortController = null;
  var requestSeq = 0;
  var busyReasons = {};

  function placeCatalogLoader() {
    var form = document.getElementById('FacetFiltersForm');
    if (!form) return null;
    var loaders = document.querySelectorAll('.ac-catalog-loader');
    var loader = null;
    Array.prototype.forEach.call(loaders, function (node) {
      if (!loader && node.querySelector('.spinner, svg')) loader = node;
    });
    if (!loader) loader = loaders[0] || null;
    if (!loader) return null;
    if (loader.parentElement !== form) form.appendChild(loader);
    Array.prototype.forEach.call(document.querySelectorAll('.ac-catalog-loader'), function (node) {
      if (node !== loader) node.remove();
    });
    return loader;
  }

  function paintCatalogBusy() {
    var busy = false;
    for (var key in busyReasons) {
      if (busyReasons[key]) busy = true;
    }
    document.documentElement.classList.toggle('ac-catalog-busy', busy);
    var loader = placeCatalogLoader();
    if (loader) {
      loader.classList.toggle('is-on', busy);
      var spinner = loader.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
    }
    document.querySelectorAll('.product-count').forEach(function (el) {
      el.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
  }

  window.acSetCatalogBusy = function (reason, on) {
    if (on) busyReasons[reason] = true;
    else delete busyReasons[reason];
    paintCatalogBusy();
  };

  // The list is ready when it is in the page. Image downloads continue without the spinner.
  window.acWhenCatalogPainted = function () {
    return new Promise(function (resolve) {
      var started = Date.now();

      function tick() {
        var grid = document.getElementById('product-grid');
        if ((grid && !grid.hasAttribute('data-ac-sort-pending')) || Date.now() - started > 4000) {
          resolve();
          return;
        }
        window.requestAnimationFrame(tick);
      }

      window.requestAnimationFrame(tick);
    });
  };

  function isPathFilterInput(target) {
    return (
      target instanceof HTMLInputElement &&
      target.matches('input[data-collection-filter-url]')
    );
  }

  function sectionId() {
    return (
      document.getElementById('product-grid')?.dataset?.id ||
      document.querySelector('#main-collection-filters')?.dataset?.id ||
      ''
    );
  }

  function sectionFetchUrl(pageUrl) {
    var id = sectionId();
    var url = new URL(pageUrl, window.location.origin);
    if (id) url.searchParams.set('section_id', id);
    return url.toString();
  }

  function setLoading(isLoading) {
    var collection = document.querySelector('#ProductGridContainer .collection');
    if (collection) collection.classList.toggle('loading', isLoading);

    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      el.classList.toggle('loading', isLoading);
    });

    document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner').forEach(
      function (spinner) {
        spinner.classList.toggle('hidden', !isLoading);
      }
    );
  }

  function syncPathFilterInputs(doc) {
    doc.querySelectorAll('input[data-collection-filter-url]').forEach(function (src) {
      var dest = document.getElementById(src.id);
      if (!dest) return;
      dest.checked = src.checked;
      dest.setAttribute('data-collection-filter-url', src.getAttribute('data-collection-filter-url') || '');
      var label = dest.closest('label');
      if (label) label.classList.toggle('active', src.checked);
    });
  }

  function syncPathFilterChrome(doc) {
    doc.querySelectorAll('details.js-filter').forEach(function (srcDetails) {
      var index = srcDetails.getAttribute('data-index') || '';
      if (
        index !== 'collection' &&
        index !== 'tag' &&
        index !== 'mobile-collection' &&
        index !== 'mobile-tag'
      ) {
        return;
      }

      var destDetails = document.getElementById(srcDetails.id);
      // Mood/Collection may have been removed by Dawn facets.js — put it back
      if (!destDetails) {
        var parentId = srcDetails.parentElement && srcDetails.parentElement.id;
        var parent = parentId ? document.getElementById(parentId) : null;
        if (!parent) {
          parent =
            index.indexOf('mobile') === 0
              ? document.querySelector('#FacetFiltersFormMobile .mobile-facets__main')
              : document.getElementById('FacetsWrapperDesktop');
        }
        if (!parent) return;
        destDetails = srcDetails.cloneNode(true);
        var after = parent.querySelector('details.js-filter[data-index="collection"], details.js-filter[data-index="mobile-collection"]');
        if (after && (index === 'tag' || index === 'mobile-tag')) {
          after.after(destDetails);
        } else {
          parent.appendChild(destDetails);
        }
        return;
      }

      var wasOpen = destDetails.hasAttribute('open');
      // Don't wipe Mood options if the server returned an empty list
      // (AND-filtered responses can briefly omit tags).
      var srcList = srcDetails.querySelector('.facets__list, .mobile-facets__list, .facets__list--vertical');
      var destList = destDetails.querySelector('.facets__list, .mobile-facets__list, .facets__list--vertical');
      var srcHasOptions =
        srcList && srcList.querySelectorAll('input[data-collection-filter-url]').length > 0;
      var destHasOptions =
        destList && destList.querySelectorAll('input[data-collection-filter-url]').length > 0;
      if (!srcHasOptions && destHasOptions && (index === 'tag' || index === 'mobile-tag')) {
        var srcSummary = srcDetails.querySelector('.facets__summary-label, .mobile-facets__summary > div');
        var destSummary = destDetails.querySelector('.facets__summary-label, .mobile-facets__summary > div');
        if (srcSummary && destSummary) destSummary.innerHTML = srcSummary.innerHTML;
        var srcHeader = srcDetails.querySelector('.facets__header');
        var destHeader = destDetails.querySelector('.facets__header');
        if (srcHeader && destHeader) destHeader.innerHTML = srcHeader.innerHTML;
      } else {
        destDetails.innerHTML = srcDetails.innerHTML;
      }
      if (wasOpen) {
        destDetails.setAttribute('open', '');
        // Submenus need .menu-opening (Dawn) — reinstate after innerHTML swap
        if (index.indexOf('mobile') === 0) {
          destDetails.classList.add('menu-opening');
          var parentMenu = destDetails.closest('.has-submenu');
          if (parentMenu) parentMenu.classList.add('submenu-open');
          var summary = destDetails.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      }
    });
  }

  function syncOtherFilters(doc, openDetailsId) {
    doc
      .querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
      )
      .forEach(function (srcFilter) {
        var index = srcFilter.getAttribute('data-index') || '';
        if (
          index === 'collection' ||
          index === 'tag' ||
          index === 'mobile-collection' ||
          index === 'mobile-tag'
        ) {
          return;
        }
        if (srcFilter.id === openDetailsId) return;

        var dest = document.getElementById(srcFilter.id);
        if (!dest || dest.hasAttribute('open')) return;
        dest.innerHTML = srcFilter.innerHTML;
      });
  }

  function syncActiveFacets(doc) {
    var shouldReopenMore = reopenMoreTooltipAfterSync;
    var reopenTipId = reopenMoreTooltipId;
    reopenMoreTooltipAfterSync = false;
    reopenMoreTooltipId = '';

    // Drop any portaled node — section HTML replace recreates pills
    clearTimeout(moreCloseTimer);
    moreCloseTimer = null;
    if (portaledTooltip) {
      portaledTooltip.remove();
      portaledTooltip = null;
      portaledTrigger = null;
    }
    document.querySelectorAll('[data-active-facets-more].is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-expanded', 'false');
    });

    placeCatalogLoader();
    ['.active-facets-desktop', '.active-facets-mobile'].forEach(function (selector) {
      var src = doc.querySelector(selector);
      var dest = document.querySelector(selector);
      if (!src || !dest) return;
      // Keep runtime classes (e.g. is-open); only sync empty state from server HTML
      dest.innerHTML = src.innerHTML;
      dest.classList.toggle('active-facets--empty', src.classList.contains('active-facets--empty'));
    });
    placeCatalogLoader();
    paintCatalogBusy();

    if (shouldReopenMore) {
      var trigger = findMoreTriggerByTipId(reopenTipId);
      if (trigger) openMoreTooltip(trigger);
    }
  }

  function findMoreTriggerByTipId(tipId) {
    if (tipId) {
      var byControls = document.querySelector(
        '[data-active-facets-more][aria-controls="' + tipId + '"]'
      );
      if (byControls) return byControls;

      if (tipId.indexOf('Collection') !== -1) {
        var collectionMore = document.querySelector(
          '[data-active-facets-more][aria-controls^="ActiveFacetsCollectionMore"]'
        );
        if (collectionMore) return collectionMore;
      }
      if (tipId.indexOf('Tag') !== -1) {
        var tagMore = document.querySelector(
          '[data-active-facets-more][aria-controls^="ActiveFacetsTagMore"]'
        );
        if (tagMore) return tagMore;
      }
    }
    return document.querySelector('[data-active-facets-more]');
  }

  function countSelectedFilters() {
    var count = 0;
    // Desktop only — mobile mirrors the same path filters
    document
      .querySelectorAll('#FacetFiltersForm input[data-collection-filter-url]:checked')
      .forEach(function () {
        count += 1;
      });
    document
      .querySelectorAll(
        '#FacetFiltersForm .js-filter:not([data-index="collection"]):not([data-index="tag"]) input[type="checkbox"]:checked'
      )
      .forEach(function (input) {
        if (input.name && input.name.indexOf('availability') !== -1) return;
        count += 1;
      });

    // Fallback: sum group counts (covers overflow +N chips) or visible pills
    if (count === 0) {
      var root = document.querySelector('[data-ac-active-facets]');
      if (root) {
        root.querySelectorAll('[data-active-count]').forEach(function (group) {
          count += parseInt(group.getAttribute('data-active-count'), 10) || 0;
        });
        if (count === 0) {
          count = root.querySelectorAll(
            '.active-facets__tags a.active-facets__chip, .active-facets__tags a.active-facets__button'
          ).length;
        }
      }
    }
    return count;
  }

  var moreCloseTimer = null;
  var lastPointer = { x: 0, y: 0 };
  var portaledTooltip = null;
  var portaledTrigger = null;
  var reopenMoreTooltipAfterSync = false;
  var reopenMoreTooltipId = '';

  function restorePortaledTooltip() {
    if (!portaledTooltip) return;
    portaledTooltip.classList.remove('is-portaled');
    portaledTooltip.removeAttribute('style');
    if (portaledTrigger && portaledTrigger.isConnected) {
      portaledTrigger.appendChild(portaledTooltip);
    } else {
      portaledTooltip.remove();
    }
    portaledTooltip = null;
    portaledTrigger = null;
  }

  function positionPortaledTooltip(trigger, tip) {
    var PAD = 8;
    var GAP = 6;
    var rect = trigger.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    tip.classList.add('is-portaled');
    tip.style.position = 'fixed';
    tip.style.right = 'auto';
    tip.style.bottom = 'auto';
    tip.style.transform = 'none';
    tip.style.left = '0px';
    tip.style.top = '0px';
    tip.style.padding = '0';

    var tipRect = tip.getBoundingClientRect();
    var tipW = tipRect.width;
    var tipH = tipRect.height;

    // Vertical: prefer above; flip below when there isn't room
    var spaceAbove = rect.top - PAD;
    var spaceBelow = vh - rect.bottom - PAD;
    var placeAbove = !(spaceAbove < tipH + GAP && spaceBelow > spaceAbove);

    var top;
    if (placeAbove) {
      top = Math.round(rect.top - tipH - GAP);
      if (top < PAD) top = PAD;
      tip.style.padding = '0 0 0.85rem';
    } else {
      top = Math.round(rect.bottom + GAP);
      if (top + tipH > vh - PAD) top = Math.max(PAD, vh - PAD - tipH);
      tip.style.padding = '0.85rem 0 0';
    }

    // Horizontal: prefer center; pin to tag start/end near screen edges
    var tipLeft = rect.left + rect.width / 2 - tipW / 2;
    if (tipLeft < PAD) {
      tipLeft = rect.left;
    } else if (tipLeft + tipW > vw - PAD) {
      tipLeft = rect.right - tipW;
    }
    tipLeft = Math.min(Math.max(tipLeft, PAD), Math.max(PAD, vw - PAD - tipW));

    tip.style.left = Math.round(tipLeft) + 'px';
    tip.style.top = Math.round(top) + 'px';
  }

  function portalMoreTooltip(trigger) {
    var tip =
      (portaledTrigger === trigger && portaledTooltip) ||
      trigger.querySelector('.active-facets__more-tooltip');
    if (!tip) return;
    if (portaledTooltip && portaledTooltip !== tip) restorePortaledTooltip();
    portaledTooltip = tip;
    portaledTrigger = trigger;
    if (tip.parentElement !== document.body) {
      document.body.appendChild(tip);
    }
    positionPortaledTooltip(trigger, tip);
  }

  function closeAllMoreTooltips(except) {
    clearTimeout(moreCloseTimer);
    moreCloseTimer = null;
    document.querySelectorAll('[data-active-facets-more].is-open').forEach(function (el) {
      if (except && el === except) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-expanded', 'false');
    });
    if (!except || portaledTrigger !== except) restorePortaledTooltip();
  }

  function openMoreTooltip(trigger) {
    clearTimeout(moreCloseTimer);
    moreCloseTimer = null;
    closeAllMoreTooltips(trigger);
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    portalMoreTooltip(trigger);
  }

  function isPointerOverMore(trigger) {
    if (!trigger || !trigger.isConnected) return false;
    var el = document.elementFromPoint(lastPointer.x, lastPointer.y);
    while (el) {
      if (el === trigger) return true;
      if (portaledTooltip && el === portaledTooltip) return true;
      if (portaledTooltip && portaledTooltip.contains(el) && portaledTrigger === trigger) return true;
      if (el.classList && el.classList.contains('active-facets__more-tooltip') && trigger.contains(el)) {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  function scheduleCloseMoreTooltip(trigger) {
    clearTimeout(moreCloseTimer);
    moreCloseTimer = setTimeout(function () {
      moreCloseTimer = null;
      if (!trigger.isConnected) return;
      if (isPointerOverMore(trigger)) return;
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (portaledTrigger === trigger) restorePortaledTooltip();
    }, 200);
  }

  function toggleMoreTooltip(trigger) {
    if (trigger.classList.contains('is-open')) {
      closeAllMoreTooltips();
    } else {
      openMoreTooltip(trigger);
    }
  }

  function canHoverOpenMore() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function refreshFacetStatus() {
    var count = countSelectedFilters();
    var roots = document.querySelectorAll(
      '[data-ac-active-facets], .active-facets-desktop, .active-facets-mobile'
    );
    roots.forEach(function (root) {
      root.classList.toggle('active-facets--empty', count === 0);
    });

    var statusRoot =
      document.querySelector('[data-ac-active-facets]') ||
      document.querySelector('.active-facets-desktop');
    if (!statusRoot) return;
    var status = statusRoot.querySelector('[data-ac-facet-status]');
    if (!status) return;

    var label;
    if (count === 0) {
      label = status.getAttribute('data-label-all') || 'Showing all products';
    } else if (count === 1) {
      label = (status.getAttribute('data-label-one') || 'Showing COUNT selection:').replace(
        /COUNT|\{\{\s*count\s*\}\}/g,
        String(count)
      );
    } else {
      label = (status.getAttribute('data-label-other') || 'Showing COUNT selections:').replace(
        /COUNT|\{\{\s*count\s*\}\}/g,
        String(count)
      );
    }
    status.textContent = label;
  }

  function syncProductCount(doc) {
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var src = doc.getElementById(id);
      var dest = document.getElementById(id);
      if (!src || !dest) return;
      dest.innerHTML = src.innerHTML;
      dest.dataset.productCount = src.dataset.productCount || '';
      dest.dataset.totalCount = src.dataset.totalCount || '';
      dest.classList.remove('loading');
    });

    // Mobile drawer header count (no stable id)
    var srcMobile = doc.querySelector('.mobile-facets__count');
    document.querySelectorAll('.mobile-facets__count').forEach(function (dest) {
      if (!srcMobile) return;
      dest.innerHTML = srcMobile.innerHTML;
    });
  }

  function finishApplySection(doc) {
    // Grid and count only. The filter/sort panel stays as the shopper left it
    // so a second click is not dropped while the section response lands.
    syncProductCount(doc);
    syncActiveFacets(doc);
    refreshFacetStatus();

    document.dispatchEvent(new CustomEvent('ac:product-tags:refit'));
    if (typeof window.acFitProductTags === 'function') window.acFitProductTags();

    document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner').forEach(
      function (spinner) {
        if (spinner.closest('.ac-catalog-loader')) return;
        spinner.classList.add('hidden');
      }
    );

    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.filterData = [];
    }
  }

  function applySectionHtml(html, openDetailsId) {
    var doc = parser.parseFromString(html, 'text/html');
    var newGrid = doc.getElementById('ProductGridContainer');
    var grid = document.getElementById('ProductGridContainer');

    // Instant swap — skip acSoftGridSwap fade-out/enter (that stacked with
    // .collection.loading and made the grid blink: dim → flash → rise from 0).
    if (newGrid && grid) {
      grid.innerHTML = newGrid.innerHTML;
      var collection = grid.querySelector('.collection');
      if (collection) collection.classList.remove('loading');
      grid.querySelectorAll('.scroll-trigger').forEach(function (element) {
        element.classList.add('scroll-trigger--cancel');
        element.classList.remove('scroll-trigger--offscreen');
      });
    }
    finishApplySection(doc);
  }

  function syncKindSwitchHrefs(pageUrl) {
    var next = new URL(pageUrl, window.location.origin);
    document.querySelectorAll('[data-ac-kind-switch] .ac-kind-switch__option').forEach(function (option) {
      var current = new URL(option.getAttribute('href') || next.pathname, window.location.origin);
      var view = current.searchParams.get('view');
      var href = next.pathname;
      if (view === 'cases' || view === 'powerbanks') href += '?view=' + view;
      option.setAttribute('href', href);
    });
  }

  function preserveProductKind(pageUrl) {
    var currentKind = new URL(window.location.href).searchParams.get('view');
    if (currentKind !== 'cases' && currentKind !== 'powerbanks') return pageUrl;
    var next = new URL(pageUrl, window.location.origin);
    if (!next.searchParams.has('view')) next.searchParams.set('view', currentKind);
    return next.pathname + next.search + next.hash;
  }

  function cssEscape(value) {
    if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function catalogBasePath() {
    var raw = '';
    var clear = document.querySelector('a.active-facets__button-remove[data-collection-filter-clear], a.mobile-facets__clear[data-collection-filter-clear]');
    if (clear) raw = clear.getAttribute('href') || '';
    if (!raw) {
      var input = document.querySelector('input[data-collection-filter-url]');
      if (input) raw = input.getAttribute('data-collection-filter-url') || '';
    }
    try {
      var path = new URL(raw, window.location.origin).pathname.replace(/\/+$/, '');
      var marker = '/collections/';
      var at = path.indexOf(marker);
      if (at !== -1) {
        var handle = path.slice(at + marker.length).split('/')[0];
        if (handle) return path.slice(0, at) + marker + handle;
      }
    } catch (e) {}
    return '/collections/all';
  }

  function pathFilterRoot() {
    return document.getElementById('FacetFiltersForm') || document.getElementById('FacetFiltersFormMobile') || document;
  }

  function buildFilterUrl() {
    var root = pathFilterRoot();
    var handles = [];
    ['filter.collection', 'filter.tag'].forEach(function (name) {
      root.querySelectorAll('input[name="' + name + '"][data-collection-filter-url]').forEach(function (el) {
        if (!el.checked || !el.value) return;
        if (handles.indexOf(el.value) === -1) handles.push(el.value);
      });
    });
    var url = catalogBasePath();
    if (handles.length) url += '/' + handles.join('+');
    return url;
  }

  function withCurrentSearch(pageUrl) {
    pageUrl = preserveProductKind(pageUrl);
    var current = new URL(window.location.href);
    var next = new URL(pageUrl, window.location.origin);
    var sort = current.searchParams.get('sort_by');
    if (sort && !next.searchParams.has('sort_by')) next.searchParams.set('sort_by', sort);
    return next.pathname + next.search + next.hash;
  }

  function mirrorPathInput(input) {
    var selector =
      'input[data-collection-filter-url][name="' +
      cssEscape(input.name) +
      '"][value="' +
      cssEscape(input.value) +
      '"]';
    document.querySelectorAll(selector).forEach(function (el) {
      el.checked = input.checked;
      var label = el.closest('label');
      if (label) label.classList.toggle('active', input.checked);
    });
  }

  function uncheckPathInputs(match) {
    document.querySelectorAll('input[data-collection-filter-url]').forEach(function (input) {
      if (match && !match(input)) return;
      input.checked = false;
      var label = input.closest('label');
      if (label) label.classList.remove('active');
    });
  }

  function applyClearSelection(link) {
    var details = link.closest('details.js-filter');
    var value = link.getAttribute('data-filter-value');
    var group = link.getAttribute('data-filter-group');

    if (details) {
      var index = details.getAttribute('data-index') || '';
      var inputName = index.indexOf('tag') !== -1 ? 'filter.tag' : 'filter.collection';
      uncheckPathInputs(function (input) {
        return input.name === inputName;
      });
      return true;
    }
    if (value) {
      uncheckPathInputs(function (input) {
        return input.value === value;
      });
      return true;
    }
    if (group === 'tag' || group === 'collection') {
      var groupName = group === 'tag' ? 'filter.tag' : 'filter.collection';
      uncheckPathInputs(function (input) {
        return input.name === groupName;
      });
      return true;
    }
    if (link.classList.contains('active-facets__button-remove') || link.classList.contains('mobile-facets__clear')) {
      uncheckPathInputs();
      return true;
    }
    return false;
  }

  function checksFromLocation() {
    var path = window.location.pathname;
    var marker = '/collections/';
    var at = path.indexOf(marker);
    var handles = [];
    if (at !== -1) {
      var rest = path.slice(at + marker.length).split('/');
      if (rest[1]) handles = rest[1].split('+').filter(Boolean);
    }
    document.querySelectorAll('input[data-collection-filter-url]').forEach(function (input) {
      var on = handles.indexOf(input.value) !== -1;
      input.checked = on;
      var label = input.closest('label');
      if (label) label.classList.toggle('active', on);
    });
  }

  function loadPathFilter(pageUrl, updateHistory) {
    pageUrl = withCurrentSearch(pageUrl);
    syncKindSwitchHrefs(pageUrl);
    var seq = ++requestSeq;
    if (abortController) abortController.abort();
    abortController = new AbortController();
    var signal = abortController.signal;
    window.acSetCatalogBusy('filter', true);

    function finishBusy() {
      window.acWhenCatalogPainted().then(function () {
        if (seq !== requestSeq) return;
        window.acSetCatalogBusy('filter', false);
      });
    }

    function readResponse(response) {
      if (!response.ok) throw new Error('Filter request failed');
      return response.text();
    }

    return fetch(sectionFetchUrl(pageUrl), { signal: signal })
      .then(function (response) {
        if (response.ok) return response.text();
        // Theme preview sometimes cannot render ?section_id= on a filtered path.
        // Load the full document and keep the open panel instead of navigating.
        return fetch(pageUrl, { signal: signal }).then(readResponse);
      })
      .then(function (html) {
        if (seq !== requestSeq) return;
        applySectionHtml(html);

        var next = new URL(pageUrl, window.location.origin);
        var searchParams = next.search ? next.search.slice(1) : '';
        if (typeof FacetFiltersForm !== 'undefined') {
          FacetFiltersForm.searchParamsPrev = searchParams;
        }
        if (updateHistory !== false) {
          history.pushState({ searchParams: searchParams, acPathFilter: true }, '', next.pathname + next.search);
        }
        finishBusy();
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (seq !== requestSeq) return;
        window.acSetCatalogBusy('filter', false);
        window.location.assign(pageUrl);
      });
  }

  function handleInput(event) {
    var input = event.target;
    if (!isPathFilterInput(input)) return;

    event.stopImmediatePropagation();

    var label = input.closest('label');
    if (label) label.classList.toggle('active', input.checked);

    mirrorPathInput(input);

    var details = input.closest('details.js-filter');
    if (details) details.setAttribute('open', '');

    refreshFacetStatus();
    loadPathFilter(buildFilterUrl());
  }

  function handleClearClick(event) {
    var link = event.target.closest('[data-collection-filter-clear]');
    if (!link) return;

    var url = preserveProductKind(link.getAttribute('href'));
    if (!url) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var fromMoreTooltip = !!(
      link.closest('.active-facets__more-tooltip') ||
      (portaledTooltip && portaledTooltip.contains(link))
    );

    if (fromMoreTooltip) {
      clearTimeout(moreCloseTimer);
      moreCloseTimer = null;
      reopenMoreTooltipAfterSync = true;
      var tip =
        link.closest('.active-facets__more-tooltip') ||
        portaledTooltip;
      reopenMoreTooltipId = (tip && tip.id) || '';
      // Keep the open chip visually locked while the section reloads
      if (portaledTrigger) {
        portaledTrigger.classList.add('is-open');
        portaledTrigger.setAttribute('aria-expanded', 'true');
      }
    } else {
      // Optimistic empty only when clearing outside the overflow tooltip
      var root = document.querySelector('[data-ac-active-facets]');
      if (root && link.classList.contains('active-facets__button-remove')) {
        root.classList.add('active-facets--empty');
        var status = root.querySelector('[data-ac-facet-status]');
        if (status) {
          status.textContent = status.getAttribute('data-label-all') || 'Showing all products';
        }
      }
    }

    if (applyClearSelection(link)) {
      refreshFacetStatus();
      loadPathFilter(buildFilterUrl());
      return;
    }
    loadPathFilter(url);
  }

  document.addEventListener('change', handleInput, true);
  document.addEventListener(
    'input',
    function (event) {
      if (!isPathFilterInput(event.target)) return;
      event.stopImmediatePropagation();
    },
    true
  );
  document.addEventListener(
    'click',
    function (event) {
      if (isPathFilterInput(event.target)) return;

      // Portaled tooltip lives on document.body — handle before generic outside-close
      if (portaledTooltip && portaledTooltip.contains(event.target)) {
        if (event.target.closest('[data-collection-filter-clear]')) {
          handleClearClick(event);
        }
        return;
      }

      var more = event.target.closest('[data-active-facets-more]');
      if (more) {
        // Allow clicks on clear links inside the in-place tooltip
        if (event.target.closest('[data-collection-filter-clear]')) {
          handleClearClick(event);
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleMoreTooltip(more);
        return;
      }

      closeAllMoreTooltips();
      handleClearClick(event);
    },
    true
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      lastPointer.x = event.clientX;
      lastPointer.y = event.clientY;
      var open = document.querySelector('[data-active-facets-more].is-open');
      if (!open) return;
      if (isPointerOverMore(open)) {
        clearTimeout(moreCloseTimer);
        moreCloseTimer = null;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerover',
    function (event) {
      if (!canHoverOpenMore()) return;
      var more = event.target.closest('[data-active-facets-more]');
      if (more) {
        openMoreTooltip(more);
        return;
      }
      if (portaledTooltip && portaledTrigger && portaledTooltip.contains(event.target)) {
        openMoreTooltip(portaledTrigger);
      }
    },
    true
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      if (!canHoverOpenMore()) return;
      var next = event.relatedTarget;
      var more = event.target.closest('[data-active-facets-more]');
      if (more) {
        if (next && (more.contains(next) || (portaledTooltip && portaledTooltip.contains(next)))) return;
        scheduleCloseMoreTooltip(more);
        return;
      }
      if (portaledTooltip && portaledTrigger && portaledTooltip.contains(event.target)) {
        if (next && (portaledTooltip.contains(next) || portaledTrigger.contains(next))) return;
        scheduleCloseMoreTooltip(portaledTrigger);
      }
    },
    true
  );

  document.addEventListener(
    'scroll',
    function () {
      if (portaledTooltip && portaledTrigger) positionPortaledTooltip(portaledTrigger, portaledTooltip);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var more = event.target.closest && event.target.closest('[data-active-facets-more]');
    if (!more) {
      if (event.key === 'Escape') closeAllMoreTooltips();
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleMoreTooltip(more);
    } else if (event.key === 'Escape') {
      closeAllMoreTooltips();
      more.focus();
    }
  });

  window.addEventListener('popstate', function (event) {
    if (!event.state || !event.state.acPathFilter) return;
    checksFromLocation();
    refreshFacetStatus();
    loadPathFilter(window.location.pathname + window.location.search, false);
  });

  // Expose for facets.js / other section re-renders
  window.acRefreshFacetStatus = refreshFacetStatus;
  function onReady() {
    refreshFacetStatus();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
